export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-3.2826c94b.png";